import { Injectable } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";
import { CustomerKbaService } from "../../services/customer-kba.service";
import { Observable } from "rxjs";
import { CustomerKbaConversation, SsoAccountFacade } from "common";
import { KbaChoiceForm, KbaData, KbaForm, KbaQuestionForm, KbaQuestionsForm } from "./model/kba-form.model";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { map, mergeMap, take } from "rxjs/operators";

@UntilDestroy()
@Injectable()
export class KbaFormFacade {

    constructor(
        private readonly kbaService: CustomerKbaService, 
        private readonly ssoAccountFacade: SsoAccountFacade) {
    }

    initData(): Observable<CustomerKbaConversation> {
        return this.kbaService.getQuestions().pipe(map((kbaConversation) => kbaConversation));
    }

    initForm(customerKbaConversation: CustomerKbaConversation): FormGroup<KbaForm> {
        return new FormGroup<KbaForm>({
            conversationId: new FormControl(customerKbaConversation.conversationId, {
                validators: [Validators.required]
            }),
            answers: new FormGroup<KbaQuestionsForm>({
                QuestionSetId: new FormControl(customerKbaConversation.questionSet.QuestionSetId, {
                    validators: [Validators.required]
                }),
                Questions: new FormArray<FormGroup<KbaQuestionForm>>(customerKbaConversation.questionSet.Questions.map(question => new FormGroup<KbaQuestionForm>({
                    QuestionId: new FormControl(question.QuestionId),
                    Choices: new FormArray<FormGroup<KbaChoiceForm>>([
                        new FormGroup<KbaChoiceForm>({
                        Choice: new FormControl('', {
                            validators: [Validators.required]
                        })
                    })])
                })))
            })
        })
    }

    save(formData: KbaData) {
        this.ssoAccountFacade.clearSsoAccountCache();

        return this.kbaService
        .answer(formData)
        .pipe(mergeMap(results => {
            return this.ssoAccountFacade.getCurrentSsoAccount$().pipe(take(1), map(currentSsoAccount => {
                return { results, currentSsoAccount };
              }))
        }));
    }
}